import authHeader from "../authentication/authservices/auth-header";
import { monitorVitalsApi } from "../http-common";

export const getPatientMonitoringList = (postObj) => {
  return monitorVitalsApi.post(`/monitordata/icumonitors`, postObj, {
    // headers: authHeader(),
  });
};

// monitordata/start
export const getStartMonitor = (postObj) => {
  return monitorVitalsApi.post(`/monitordata/start`, postObj, {
    // headers: authHeader(),
  });
};

//monitordata/realtime

export const getMonitorData = (postObj) => {
  return monitorVitalsApi.post(`/monitordata/realtime`, postObj, {
    // headers: authHeader(),
  });
};

// service to mute or acknowledge the attentions
export const acknowledgeAttention=(postObject)=>{
  return monitorVitalsApi.post(`/monitordata/saveAck`, postObject, {
    // headers: authHeader(),
  });
}
